import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';

import {DocToc, PageHero, PageShell, PageTitle, Prose, Section} from 'components';

import EnContent from './content/en';
import KoContent from './content/ko';
import RuContent from './content/ru';
import ZhContent from './content/zh';

/**
 * TermsOfUse（i18n 壳）：正文按语言选择 content/zh|en|ko|ru 内容组件，法律文字 1:1 保留
 * （ko/ru 为 2026-09-17 AI 翻译，法律措辞待业务方校对）。v3 改版：soft hero（badge+标题）
 * + Prose 文档排版，弃用各页原 BEM 类名样式。
 */
const TermsOfUse: FC = () => {
  const {i18n, t} = useTranslation('legal');
  const contentByLang: Record<string, FC> = {en: EnContent, ko: KoContent, ru: RuContent};
  const Content = contentByLang[i18n.language] ?? ZhContent;
  const heroTitle = t('termsOfUse.title').split(' - ')[0];

  return (
    <PageShell>
      <PageTitle canonicalUrl="https://www.xiangjifanyi.com/home/terms-of-use" title={t('termsOfUse.title')} />
      <PageHero badge={t('badge')} title={heroTitle} variant="soft" />
      <Section compact>
        <div className="max-w-[79rem] mx-auto xl:grid xl:grid-cols-[12.5rem_minmax(0,48rem)_12.5rem] xl:gap-12">
          {/* 左占位列：与目录等宽，正文保持页面正中（目录仅 xl+ 显示） */}
          <div aria-hidden="true" className="hidden xl:block" />
          <Prose>
            <Content />
          </Prose>
          <DocToc className="hidden xl:block" />
        </div>
      </Section>
    </PageShell>
  );
};

export default TermsOfUse;
